/**
 * Toast notification system — a fixed-position stack above the tab bar.
 * Any screen imports `showToast` directly; no store subscription needed.
 */
export type ToastType = 'info' | 'success' | 'error';

let container: HTMLDivElement | null = null;

const TYPE_CLASSES: Record<ToastType, string> = {
  info: 'border-border text-text',
  success: 'border-success/50 text-success',
  error: 'border-error/50 text-error',
};

export function mountToastContainer(root: HTMLElement): void {
  container = document.createElement('div');
  container.id = 'toast-container';
  container.className = 'fixed left-1/2 -translate-x-1/2 bottom-[calc(64px+env(safe-area-inset-bottom)+12px)] z-50 flex flex-col gap-2 w-[calc(100%-24px)] max-w-[420px] pointer-events-none';
  root.appendChild(container);
}

export function unmountToastContainer(): void {
  container?.remove();
  container = null;
}

export function showToast(message: string, type: ToastType = 'info', durationMs = 4000): void {
  if (!container) return;

  const el = document.createElement('div');
  el.className = `pointer-events-auto px-4 py-3 rounded-lg border bg-surface shadow-lift text-sm ${TYPE_CLASSES[type]} transition-opacity duration-300`;
  el.textContent = message;
  container.appendChild(el);

  setTimeout(() => {
    el.style.opacity = '0';
    setTimeout(() => el.remove(), 300);
  }, durationMs);
}
